import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    list: '/dashboard/v3/event-owner/',
    detail: '/dashboard/v3/event-owner/{id}/',
    checkDependencies: '/dashboard/v3/event-owner/{id}/check_dependencies/',
}

export default {
    async fetchEventOwnerList(filters, pagination, sorting) {
        if (!filters) filters = {}
        if (!pagination) pagination = {}
        if (!sorting) sorting = {}

        let result = await client.get(endpoints.list, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.asc ? `-${sorting.column}` : sorting.column ?? ''
        })

        // Calculate num_pages from count and page_size
        const pageSize = pagination.page_size ?? 20
        const numPages = Math.ceil(result.count / pageSize)

        return {
            results: result.results,
            pagination: {
                num_pages: numPages,
                page_size: pageSize,
                page: pagination.page ?? 1,
                total: result.count,
            }
        }
    },
    async fetchEventOwner(id) {
        return await client.get(endpoints.detail.replace('{id}', id))
    },
    async createEventOwner(data) {
        return await client.post(endpoints.list, data)
    },
    async updateEventOwner(id, data) {
        return await client.patch(endpoints.detail.replace('{id}', id), data)
    },
    async deleteEventOwner(id, force = false) {
        const params = force ? { force: '1' } : {}
        return await client.delete(endpoints.detail.replace('{id}', id), params)
    },
    async checkEventOwnerDependencies(id) {
        return await client.get(endpoints.checkDependencies.replace('{id}', id))
    },
}
